import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  TextField,
  InputAdornment,
  MenuItem,
  Button,
  Stack,
  Select,
  Box,
} from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";

const FormComponent = ({ info, setInfo, handleSubmit, isAdd }) => {
  const handleChange = (e) => {
    // const name=e.target.name;
    // const value=e.target.value;
    // Yukarıdaki işlemlerin kısayolu:
    const { name, value } = e.target;
    setInfo({ ...info, [name]: value });

    e.preventDefault();
  };

  return (
    <Grid
      textAlign="center"
      verticalAlign="middle"
      direction="column"
      style={{ width: "300" }}
    >
      <h2
        className="contact-header"
        style={{ marginBottom: "20px", fontSize: "2rem", color: "#ADE792" }}
      >
        Contact Form
      </h2>

      <Box
        style={{
          padding: "40px",
          backgroundColor: "#344D67",
          borderRadius: "20px",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Stack spacing={3} direction="column">
            <TextField
              sx={{ backgroundColor: "white", borderRadius: "10px" }}
              variant="outlined"
              name="username"
              value={info.username}
              onChange={handleChange}
              placeholder="Name"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              sx={{ backgroundColor: "white", borderRadius: "10px" }}
              variant="outlined"
              name="phoneNumber"
              value={info.phoneNumber}
              onChange={handleChange}
              placeholder="Phone Number"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PhoneEnabledIcon />
                  </InputAdornment>
                ),
              }}
            />
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <InputLabel style={{ paddingLeft: "20px" }}>Gender</InputLabel>
              <Select
                sx={{ backgroundColor: "white", borderRadius: "10px" }}
                label="Gender"
                name="gender"
                variant="outlined"
                value={info.gender}
                onChange={handleChange}
              >
                <MenuItem value="Female">Female</MenuItem>
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
            </FormControl>
            <Button variant="contained" type="submit" value="Submit">
              {isAdd}
            </Button>
          </Stack>
        </form>
      </Box>
    </Grid>
  );
};

export default FormComponent;
